import { c as _c } from "react/compiler-runtime";
import { Flex, VStack, Separator } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { PodcastList } from '@src/components/sco/Education/PodcastLanding/PodcastList';
import { PodcastSubscribe } from '@src/components/sco/Education/PodcastLanding/PodcastSubscribe';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { useWindow } from '@src/hooks/useWindow';
import React from 'react';
export const PodcastSearch = () => {
  const $ = _c(11);
  const educationContext = useEducationContext();
  const window = useWindow();
  let t0;
  if ($[0] !== educationContext || $[1] !== window?.location?.href) {
    t0 = () => {
      educationContext.setBreadcrumbs([{
        title: "Podcast",
        href: "/podcast"
      }, {
        title: `${[...educationContext.activeTerms.map(_temp), educationContext.activeKeywords && `"${educationContext.activeKeywords}"`].filter(Boolean).join(" + ")}`,
        href: window?.location?.href
      }]);
    };
    $[0] = educationContext;
    $[1] = window?.location?.href;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== educationContext.activeKeywords || $[4] !== educationContext.activeTerms) {
    t1 = [educationContext.activeKeywords, educationContext.activeTerms];
    $[3] = educationContext.activeKeywords;
    $[4] = educationContext.activeTerms;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useUniversalEffect(t0, t1);
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PodcastSubscribe />;
    t3 = <Separator borderColor="colorPalette.border" />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== educationContext.activeKeywords || $[9] !== educationContext.activeTermsSlugs) {
    t4 = <Flex align="center" justify="center" width="full"><VStack gap={10} maxWidth="container.xl" padding={10} width="full">{t2}{t3}<PodcastList keywords={educationContext.activeKeywords} termSlugs={educationContext.activeTermsSlugs} title="Podcast Episodes" /></VStack></Flex>;
    $[8] = educationContext.activeKeywords;
    $[9] = educationContext.activeTermsSlugs;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(t) {
  return t.name;
}